import React, { useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";

import AuthContext from "../../contexts/AuthCtx";
import DashboardLayout from "../../components/Dashboard/DashboardLayout";
import {
  LetterDialogActions,
  letterModalBodyClass,
  letterModalCloseClass,
  letterModalTitleClass,
} from "../../components/UX/LetterDialog";
import { captureEvent } from "../../analytics";

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const { updateHandler } = useContext(AuthContext);
  const trackedRef = useRef(false);

  useEffect(() => {
    updateHandler();
    if (!trackedRef.current) {
      trackedRef.current = true;
      captureEvent("stamp_purchased", {
        source: "stripe_checkout_success",
      });
    }
  }, [updateHandler]);

  return (
    <DashboardLayout showFeedback={false}>
      <div className="flex min-h-[60vh] items-center justify-center px-4">
        <div className="relative w-full max-w-md rounded-xl bg-modalBg p-10 shadow-xl sm:p-12">
          <button
            type="button"
            onClick={() => navigate("/dashboard")}
            className={letterModalCloseClass}
            aria-label="Fermer"
          >
            <X size={20} strokeWidth={1.5} />
          </button>
          <h2 className={`${letterModalTitleClass} text-center px-6`}>
            Succès du paiement
          </h2>
          <p className={`${letterModalBodyClass} text-center`}>
            Tu as effectué le paiement avec succès. Tes timbres seront ajoutés
            à ton compte.
          </p>
          <LetterDialogActions
            primaryLabel="Aller au tableau de bord"
            onPrimary={() => navigate("/dashboard")}
            primaryVariant="purple"
          />
        </div>
      </div>
    </DashboardLayout>
  );
};

export default PaymentSuccess;
